import React from 'react';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import { MetaCollectionRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaCollectionRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDLabelText, FDDisplayText, FDBodyText } from '@facet-wealth/design';
import TaxDiagnosticMessageLayout from './TaxDiagnosticMessageLayout';


const TaxDiagnosticMessageMetaOverride = buildFacetDesignOverride()
  .nameOverride('header', {
    _component: () => FDLabelText,
    _customProps: {
      align: 'center',
      size: 'lg',
    },
  }, overrideReadOnly)
  .nameOverride('title', {
    _component: () => FDDisplayText,
    _customProps: { align: 'center', color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride('subtitle', {
    _component: () => FDDisplayText,
    _customProps: { size: 'sm', align: 'center', color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride('footer', {
    _component: () => FDBodyText,
    _customProps: { size: 'sm', align: 'center' },
  }, overrideReadOnly);


const TaxDiagnosticMessage = ({ relationship }) => {
  const { collection, isInitializing, loadingError } = useLink(relationship);

  return (
    <DataContainer
      component={MetaCollectionRenderer}
      componentProps={{
        collection,
        metaOverrideSet: TaxDiagnosticMessageMetaOverride,
        layout: TaxDiagnosticMessageLayout,
      }}
      loading={isInitializing}
      loadingError={loadingError}
    />
  );
};

TaxDiagnosticMessage.propTypes = {
  relationship: PropTypes.object.isRequired,
};
TaxDiagnosticMessage.defaultProps = {};

export default TaxDiagnosticMessage;
